import { http } from 'interfaces'
import { type LutValues } from './lutValuesService'

export interface Region {
  desc: string
  countryId: number | null
  id: number
}
export interface RegionLutValues extends LutValues {
  regions: Region []
}

export async function getRegions (): Promise<RegionLutValues> {
  return await http.get('/api/v1/region/lut/').then(value => value.data)
}

export async function addRegion (region: Region): Promise<Region> {
  return await http.post('/api/v1/region/lut/', { ...region }).then(response => response.data)
}
